
<div class="header-toolbar">
  <h1>
    Comptes clients

    <span class="tag" *ngIf="filter.search">
      <span class="text">Recherche: {{ filter.search }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearSearch()"></t-icon>
    </span>
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'/shares-ledger/client-accounts/new'">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </a>
      <button class="btn" (click)="applyFilter()">
        <t-icon name="search"></t-icon>
        <span class="text">Filtrer</span>
      </button>

    </div>
  </div>

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'deleted'">
        <t-icon name="folder"></t-icon>
        <span class="text">Supprimés</span>
      </a>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th>Nom</th>
      <th style="width: 110px">Date d'ajout</th>
      <th style="width: 100px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="accounts && accounts.length > 0">
    <tr *ngFor="let account of accounts" (click)="showCLAccount(account, $event)">
      <td name="Nom">
        {{ account.name }}
      </td>
      <td name="Date d'ajout" style="width: 110px">
        {{ account.createdAt | tzdate:'short' }}
      </td>
      <td style="width: 100px;" class="actions">
        <a class="action-btn" title="Modifer" [routerLink]="[account.id, 'edit']">
          <t-icon name="mode_edit"></t-icon>
        </a>
        <a class="action-btn" title="Supprimer" (click)="delete(account)">
          <t-icon name="delete"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!accounts || accounts.length == 0">
    <tr>
      <td class="text-center" colspan="3">
        <ng-container *ngIf="accounts && accounts.length == 0">
          Aucun compte n'a été trouvé
        </ng-container>
        <ng-container *ngIf="!accounts">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="accounts">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="accounts.length < accountsCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ accounts.length }} / {{ accountsCount }}
  </div>
</div>